import { PostJobButton } from "@components/Layout/Header/PostJobButton";
import React, { FC } from "react";

interface Props {}

export const Hero: FC<Props> = ({}) => {
  return (
    <div className="px-6 text-center">
      <h1 className="text-4xl tracking-tight font-black text-black sm:text-5xl md:text-6xl">
        <span className="block text-yellow-400 xl:inline">
          Hire JavaScript Developers
        </span>{" "}
      </h1>
      <p className="mt-3 max-w-md mx-auto text-base text-black sm:text-lg md:mt-5 md:text-xl md:max-w-xl">
        Reach a community of highly skilled JavaScript & TypeScript developers
        from all over the world.
      </p>
      <div className="my-6">
        <PostJobButton cN="rounded text-white bg-black hover:text-yellow-300" />
      </div>
    </div>
  );
};
